import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
interface ManualProps {
  number: string;
  title: string;
  delay: number;
  rotation: number;
  zIndex: number;
  xOffset: number;
}
const MODULE_COVERS: Record<string, string> = {
  '1': 'https://cdn.magicpatterns.com/uploads/a1FEocdNHNBvyXakAamyW8/PORTADA_MODULO_1web.png',
  '2': 'https://cdn.magicpatterns.com/uploads/ajR14EnHkjR7pf88KeU62q/1_PORTADA_MODULO_2_web.png',
  '3': 'https://cdn.magicpatterns.com/uploads/q3pKPAZcWK2HzZkGKnSH6t/PORTADA_MODULO_3_web.png'
};
const Manual = ({
  number,
  title,
  delay,
  rotation,
  zIndex,
  xOffset
}: ManualProps) => {
  const coverImage = MODULE_COVERS[number];
  return <motion.div initial={{
    opacity: 0,
    y: 50,
    rotateZ: rotation - 10
  }} whileInView={{
    opacity: 1,
    y: 0,
    rotateZ: rotation
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    type: 'spring',
    bounce: 0.4
  }} className="absolute top-0 left-0 w-48 sm:w-56 aspect-[1/1.4] perspective-1000" style={{
    zIndex,
    x: xOffset,
    transformOrigin: 'bottom center'
  }} data-id="element-301">
      <div className="w-full h-full relative preserve-3d transition-transform duration-500 hover:-translate-y-4 hover:rotate-0 cursor-default group" data-id="element-302">
        {/* Book Cover */}
        <div className="absolute inset-0 bg-gradient-to-br from-zinc-800 to-ed-darker rounded-r-md rounded-l-sm border border-zinc-700/50 shadow-2xl overflow-hidden" data-id="element-303">
          {coverImage ? <>
              <img src={coverImage} alt={`Manual Módulo ${number} — ${title}`} className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-304" />
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent opacity-30 pointer-events-none" data-id="element-305"></div>
            </> : <>
              {/* Spine highlight */}
              <div className="absolute left-0 top-0 bottom-0 w-3 bg-gradient-to-r from-ed-green/80 to-ed-green-dark/80 border-r border-black/20 z-10" data-id="element-306"></div>

              {/* Cover content */}
              <div className="absolute inset-0 pl-6 p-4 flex flex-col justify-between" data-id="element-307">
                <div className="flex justify-between items-start" data-id="element-308">
                  <span className="text-ed-green font-black text-2xl opacity-80" data-id="element-309">
                    M{number}
                  </span>
                  <Zap className="w-5 h-5 text-zinc-600 group-hover:text-ed-yellow transition-colors" data-id="element-310" />
                </div>

                <div className="space-y-1" data-id="element-311">
                  <div className="text-[10px] text-zinc-400 uppercase tracking-widest font-semibold" data-id="element-312">
                    Manual Oficial
                  </div>
                  <h3 className="text-white font-black text-xl leading-tight uppercase" data-id="element-313">
                    {title}
                  </h3>
                </div>

                <div className="w-full h-1 bg-zinc-800 rounded-full overflow-hidden" data-id="element-314">
                  <div className="w-1/3 h-full bg-ed-green" data-id="element-315"></div>
                </div>
              </div>

              {/* Glossy overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-transparent opacity-50 pointer-events-none" data-id="element-316"></div>
            </>}
        </div>

        {/* Book Pages Edge (Right) */}
        <div className="absolute top-1 bottom-1 -right-1.5 w-1.5 bg-zinc-300 rounded-r-sm transform translate-z-[-2px]" data-id="element-317"></div>
      </div>
    </motion.div>;
};
export function ManualsVisual({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full max-w-[320px] sm:max-w-[400px] aspect-square mx-auto flex items-center justify-center ${className}`} data-id="element-318">
      {/* Background glow */}
      <div className="absolute inset-0 bg-ed-green/20 blur-[80px] rounded-full transform scale-75" data-id="element-319"></div>

      <div className="relative w-48 sm:w-56 h-[268px] sm:h-[313px]" data-id="element-320">
        <Manual number="1" title="Fundamentos" delay={0.2} rotation={-12} zIndex={10} xOffset={-40} data-id="element-321" />
        <Manual number="2" title="Montaje" delay={0.4} rotation={0} zIndex={20} xOffset={0} data-id="element-322" />
        <Manual number="3" title="Instalación" delay={0.6} rotation={12} zIndex={30} xOffset={40} data-id="element-323" />
      </div>
    </div>;
}